import * as React from 'react';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { createTheme } from '@mui/material/styles';
import { AppProvider } from '@toolpad/core/AppProvider';
import { DashboardLayout } from '@toolpad/core/DashboardLayout';
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone';
import FactCheckTwoToneIcon from '@mui/icons-material/FactCheckTwoTone';
import StarTwoToneIcon from '@mui/icons-material/StarTwoTone';
import RuleTwoToneIcon from '@mui/icons-material/RuleTwoTone';
import { Box } from '@mui/material';
import FortTwoToneIcon from '@mui/icons-material/FortTwoTone';
import ContactMailTwoToneIcon from '@mui/icons-material/ContactMailTwoTone';
import GeneralPage from './Pages/GeneralPage';
import HomePage from './Pages/HomePage';
import StatePage from './Pages/StatePage';
import TestPage from './Pages/TestPage';
import RecordsPage from './Pages/RecordsPage';
import Footer from './components/Footer';
import SocialBar from './components/SocialBar';
import ContactPage from './Pages/ContactPage';
import { initGA, logPageView } from './Tracking/GA4';

const NAVIGATION = [
    {
        kind: 'header',
        title: 'Verwalten',
    },
    {
        segment: 'home',
        title: 'Startseite',
        icon: <HomeTwoToneIcon />,
    },
    {
        segment: 'general',
        title: 'Allgemeine Fragen',
        icon: <FactCheckTwoToneIcon />,
    },
    {
        segment: 'state',
        title: 'Bundesland',
        icon: <FortTwoToneIcon />,
    },
    {
        segment: 'test',
        title: 'Prüfung',
        icon: <RuleTwoToneIcon />,
    },
    {
        segment: 'records',
        title: 'Stern',
        icon: <StarTwoToneIcon />,
    },
    {
        segment: 'contact',
        title: 'Kontakt',
        icon: <ContactMailTwoToneIcon />,
    },
];

const demoTheme = createTheme({
    cssVariables: {
        colorSchemeSelector: 'data-toolpad-color-scheme',
    },
    colorSchemes: {
        light: {
            palette: {
                background: {
                    default: '#fdf6e3',
                    paper: '#eee8d5',
                },
            },
        },
        dark: {
            palette: {
                background: {
                    default: '#002b36',
                    paper: '#073642',
                },
            },
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 600,
            lg: 1200,
            xl: 1536,
        },
    },
});

function DemoPageContent({ pathname }) {
    return (
        <>
            <SocialBar />
            <Box sx={{ my: 2 }}></Box>
            {pathname === '/home' ? (
                <HomePage />
            ) : pathname === '/general' ? (
                <GeneralPage />
            ) : pathname === '/state' ? (
                <StatePage />
            ) : pathname === '/test' ? (
                <TestPage />
            ) : pathname === '/records' ? (
                <RecordsPage />
            ) : pathname === '/contact' ? (
                <ContactPage />
            ) : (
                <HomePage />
            )}
            {/* </Container> */}
            <Box sx={{ my: 2 }}></Box>
            <Footer />
        </>
    );
}

DemoPageContent.propTypes = {
    pathname: PropTypes.string.isRequired,
};

function DashboardLayoutAccountSidebar(props) {
    useEffect(() => {
        // Initialize Google Analytics
        initGA();
        logPageView('/home');
    }, []);
    const { window } = props;

    const [pathname, setPathname] = React.useState('/home');

    const router = React.useMemo(() => {
        return {
            pathname,
            searchParams: new URLSearchParams(),
            navigate: (path) => {
                setPathname(String(path));
                logPageView(path);
            },
        };
    }, [pathname]);

    // Remove this const when copying and pasting into your project.
    const demoWindow = window !== undefined ? window() : undefined;

    return (
        <AppProvider
            navigation={NAVIGATION}
            router={router}
            theme={demoTheme}
            branding={{
                logo: (
                    <img
                        src="https://upload.wikimedia.org/wikipedia/commons/8/8e/Flag_map_of_Germany.svg"
                        // src={SvgIcon}
                        alt="Leben in Deutschland"
                    />
                ),
                title: 'Leben in Deutschland',
            }}
            window={demoWindow}
        >
            <DashboardLayout defaultSidebarCollapsed={true}>
                <DemoPageContent
                    pathname={pathname}
                    sx={{
                        '& > main': {
                            overflow: 'auto',
                            backgroundColor: 'lightblue',
                        },
                    }}
                />
            </DashboardLayout>
        </AppProvider>
    );
}

export default DashboardLayoutAccountSidebar;
